import * as React from 'react'
import { sizes } from './const'

export interface EllipsisProps {
    className?: string
    orientation?: 'horizontal' | 'vertical'
    size?: 'small' | 'medium' | 'large'
}

export const EllipsisIcon = ({
    className = 'js_EllipsisIcon',
    size = 'medium',
    orientation = 'vertical',
}: EllipsisProps) => {
    return orientation === 'vertical' ? (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className={`${className} ${sizes[size]}`}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={1}
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M11 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm0-6a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm0 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z"
            />
        </svg>
    ) : (
        <svg
            className={`${className} ${sizes[size]}`}
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            stroke="currentColor"
        >
            <path
                d="M8.49998 8.66667C8.86817 8.66667 9.16665 8.36819 9.16665 8C9.16665 7.63181 8.86817 7.33333 8.49998 7.33333C8.13179 7.33333 7.83331 7.63181 7.83331 8C7.83331 8.36819 8.13179 8.66667 8.49998 8.66667Z"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4.49998 8.66667C4.86817 8.66667 5.16665 8.36819 5.16665 8C5.16665 7.63181 4.86817 7.33333 4.49998 7.33333C4.13179 7.33333 3.83331 7.63181 3.83331 8C3.83331 8.36819 4.13179 8.66667 4.49998 8.66667Z"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.5 8.66667C12.8682 8.66667 13.1666 8.36819 13.1666 8C13.1666 7.63181 12.8682 7.33333 12.5 7.33333C12.1318 7.33333 11.8333 7.63181 11.8333 8C11.8333 8.36819 12.1318 8.66667 12.5 8.66667Z"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
